import { clsx } from "clsx";
import { useState } from "react";

import Promotion from "common/components/Promotion";
import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerContent,
  DrawerTrigger,
} from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { AppSumoPromotion, LTDPromotion } from "common/types";

import ResetSeats from "./ResetSeats";

export default function ManagePromotion({
  promotion,
}: {
  promotion: AppSumoPromotion | LTDPromotion;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const isDesktop = useTwBreakpoint("lg");
  const [stepId, setStepId] = useState<"assign" | "reset">("assign");

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;
  const Trigger = isDesktop ? DialogTrigger : DrawerTrigger;

  const stepsComponents = {
    assign: (
      <Promotion
        promotion={promotion}
        onReset={() => setStepId("reset")}
        onClose={() => setIsOpen(false)}
      />
    ),
    reset: (
      <ResetSeats goBack={() => setStepId("assign")} source={promotion.type} />
    ),
  };

  const promotionName =
    promotion.type === "appsumo" ? "AppSumo" : "lifetime deal";

  return (
    <Component
      open={isOpen}
      onOpenChange={setIsOpen}
      onAfterClose={() => setStepId("assign")}
    >
      <Trigger asChild>
        <Button
          variant={
            promotion.type === "appsumo" ? "secondary-black" : "default-black"
          }
          className={clsx(
            "max-lg:flex-1",
            promotion.type === "appsumo" && "bg-appsumoYellow",
          )}
          size={isDesktop ? "sm" : "md"}
        >
          Manage {promotionName}
        </Button>
      </Trigger>
      <Content
        className={clsx(
          "transition-none",
          stepId === "reset" && "lg:w-[448px]",
        )}
      >
        {stepsComponents[stepId]}
      </Content>
    </Component>
  );
}
